// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__13xm9","actions":"GroupTable_actions__3XLKh","deleteModalFooter":"GroupTable_deleteModalFooter__2SjW9"};